module.exports = __webpack_public_path__ + "static/media/onfleet-logo-white.8a1029ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onfleet-logo-white.svg
// module id = 2454
// module chunks = 0